import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@mui/material';

// AD-2689 (Maria, 14 October 2026): how to add and exclude groups, and what 'Must appear in all selected groups' does,
// written on the page (not hover text, as it is important). The same words in the Create Form box and Form Settings.
// AD-2699: the Create Report box uses the same words, about the report instead of the form. The 'Add group' box
// stays open for several groups until 'Done' (Maria, 15 October 2026).
// An email communication says 'the email is sent to' (walkthrough finding, 15 October 2026).
const GroupsHelpText = ({who = 'children', sx, forReport = false, noun = 'form'}) => (
    <Typography variant="body2" sx={sx} data-testid="groups-help">
        Click on &apos;Add Group&apos;, select a group (click on the black arrows to expand the filters) and click on
        &apos;Add&apos;. To exclude a group, tick Exclude Group first. Add as many groups as you need and click on
        &apos;Done&apos;. With more than one group, the
        {forReport ? ' report includes ' : ` ${noun} is sent to `}{who} in <b>at least one</b> of them. Tick &apos;Must
        appear in all selected groups&apos; to {forReport ? 'include only ' : 'send it only to '}{who} in <b>all</b> of them.
    </Typography>
);

GroupsHelpText.propTypes = {
    who: PropTypes.oneOf(['children', 'employees', 'enquiries']),
    sx: PropTypes.object,
    forReport: PropTypes.bool,
    noun: PropTypes.oneOf(['form', 'email']),
};

export default GroupsHelpText;
